export const downloadFile = ({ url, fileName, revoke = true }) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  if (revoke) {
    window.URL.revokeObjectURL(url);
  }
};
